<template>
    
    <div class="container text-center mt-5">
        <h1 class="notFound-big">Errore 404 <br> Pagina non trovata</h1>
    </div>

</template>

<script>
  export default {
    name: "NotFound"
  }
</script>

<style scoped>

</style>
